import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';

import TagDiscussionModal from './components/TagDiscussionModal';
import PostControls from 'flarum/forum/utils/PostControls';
import AlertUtil from 'flarum/common/dianLiang/AlertUtil';

export default function () {
  // Add a control allowing the discussion to be moved to another category.
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (discussion.canTag()) {
      items.add(
        'tags',
        <Button icon="fas fa-tag" onclick={() => {
          app.modal.show(TagDiscussionModal, { discussion })
          if (!app.session.user.isAdmin()) {
            let time = app.forum.attribute('postEditTime');
            AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.edit_content',{time: time}));
          }
          }}>
          {app.translator.trans('flarum-tags.forum.discussion_controls.edit_tags_button')}
        </Button>
      );
    }
  });

  extend(PostControls, 'moderationControls', function (items, post) {
    let discussion = post.discussion();
    if (post.number() == 1 && discussion.canTag()) {
      items.add(
        'tags',
        <Button icon="fas fa-tag" onclick={() => {
          app.modal.show(TagDiscussionModal, { discussion })
          if (!app.session.user.isAdmin()) {
            let time = app.forum.attribute('postEditTime');
            AlertUtil.onWarn(app, app.translator.trans('dl-response.forum.edit_content',{time: time}));
          }
          }}>
          {app.translator.trans('flarum-tags.forum.discussion_controls.edit_tags_button')}
        </Button>
      );
    }
  });
}
